import React from 'react';
import * as Icons from 'lucide-react';

type IconName = keyof typeof Icons;

export function resolveLucideIcon(
  name: string,
  size = 20,
  strokeWidth = 1.75,
): React.ReactNode {
  const Cmp = (Icons[name as IconName] ?? Icons.Square) as React.ComponentType<{
    size?: number;
    strokeWidth?: number;
  }>;
  return <Cmp size={size} strokeWidth={strokeWidth} />;
}
